const HeaderPage = {
    TH: "สร้างสกุลเงิน",
    EN: "Create Currency",
    CN: "创造条件",
    UPDATE_EN: 'Update Currency'
}

const BodyPage = [
    [{
        title_TH: "ชื่อ", title_EN: "Currency Name", title_CN: "名称",
        type: "text",
        isRequired: true,
        stateName: "name",
        placeholder_TH: "ชื่อ", placeholder_EN: "Insert Name", placeholder_CN: "插入名称"
    }], [{
        title_TH: "ประเภทสกุลเงิน", title_EN: "Currency Type", title_CN: "包装类型",
        type: "text",
        isRequired: true,
        stateName: "currencyType",
        placeholder_TH: "ประเภทสกุลเงิน", placeholder_EN: "Insert Currency Type", placeholder_CN: "插入名称"
    }], [{
        title_TH: "ลักษณะ", title_EN: "Description", title_CN: "描述",
        type: "text-multiline",
        isRequired: true,
        stateName: "description",
        placeholder_TH: "ลักษณะ", placeholder_EN: "Insert Description", placeholder_CN: "插入说明"
    }], [{
        title_TH: "สถานะ", title_EN: "Status", title_CN: "状态",
        type: "switch",
        stateName: "actived",
    }]
];

export default {
    HeaderPage,
    BodyPage,
}